var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTestEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none",
  viewBox: "0 0 48 48"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#333",
  strokeWidth: 1.25,
  clipPath: "url(#test-email_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M41.5 21.5a.293.293 0 0 1 .5.207V42a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V21.707c0-.26.315-.392.5-.207v0M7 22l13 9m21-9-13 9M6 21.5l4-3m32 3-4-3"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M10 23.5v-18a.5.5 0 0 1 .5-.5h27a.5.5 0 0 1 .5.5v18M41.5 42.5 24.638 28.529a1 1 0 0 0-1.276 0L6.5 42.5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 16.5,
  r: 6.875
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m20.786 16.857 2.5 2.857L27 14"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "test-email_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h48v48H0z"
})))));
export { SvgTestEmail as ReactComponent };